import React, { createContext, useContext, useState, useEffect } from "react";

const defaultTheme = {
  colors: {
    primary: "#ff4400ff", // default Bootstrap primary
    secondary: "#6c757d",
    success: "#198754",
    danger: "#dc3545",
  },
  icons: {
    save: "bi-save",
    delete: "bi-trash",
    edit: "bi-pencil",
  },
};

const ThemeContext = createContext({
  theme: defaultTheme,
  setTheme: () => {},
});

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(defaultTheme);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--bs-primary",
      theme.colors.primary
    );
    document.documentElement.style.setProperty(
      "--bs-secondary",
      theme.colors.secondary
    );
    document.documentElement.style.setProperty(
      "--bs-success",
      theme.colors.success
    );
    document.documentElement.style.setProperty(
      "--bs-danger",
      theme.colors.danger
    );
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
